<template>
  <v-tabs v-model="tab" color="primary" centered flat>
    <v-tab :key="index + 100" v-for="(lang, index) in localValue">{{
      lang.name
    }}</v-tab>
    <v-tab-item :key="index + 200" v-for="(lang, index) in localValue">
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            v-model="lang.text"
            @input="onChange"
            :label="localLabel(lang.langId === defaultValues.languageRequire)"
            :data-vv-name="label"
            :error-messages="errors.collect(label)"
            v-validate="{
              required: lang.langId === defaultValues.languageRequire
            }"
            v-bind="$attrs"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  name: 'TranslationField',
  props: {
    value: {
      type: Array,
      required: false,
      default: () => []
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      tab: 0
    }
  },
  watch: {
    value(val) {
      if (val && val.length === 0) this.tab = 0
    }
  },
  computed: {
    localValue: {
      get() {
        return this.converter(this.value)
      },
      set(value) {
        this.$emit('input', value)
      }
    },

    validations() {
      return this.required ? 'required' : ''
    }
  },
  methods: {
    localLabel(isoRequired) {
      let label = this.label
      if (this.required && isoRequired) label += ' *'
      return label
    },
    onChange() {
      let name = []
      this.localValue.forEach(item => {
        if (item.text) name.push(item)
      })
      this.$emit('input', name)
    }
  }
}
</script>
